import { arrayOf, Schema } from 'normalizr';


export const AFFILIATE_PROGRAM_SCHEMA = new Schema('affiliatePrograms');

export const AFFILIATE_PROGRAMS_SCHEMA = arrayOf(AFFILIATE_PROGRAM_SCHEMA);
